import { render, staticRenderFns } from "./kosten.vue?vue&type=template&id=05b5fcc6&"
import script from "./kosten.vue?vue&type=script&lang=js&"
export * from "./kosten.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports